import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { InputForm, SelectFormm } from "../../components/molecules/forms/index";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DetailDataSkeleton from "../../components/template/skeleton/DetailDataSkeleton";
import Swal from "sweetalert2";
import {
  useCreateDetokenMaskMutation,
  useGetMaskPolicyNameMutation,
  useGetPolicyNameMutation,
} from "../../store/feature/service/tokenization";
import detokenMask from "../../utils/validation/detokenMask";

const DetokenMask = () => {
  // REGION: INIT VARIABLES
  const location = useLocation();
  const { pathname } = location;
  const [optKey, setOptKey] = useState([]);
  const [optKeyMask, setOptKeyMask] = useState([]);
  const editFgroup = pathname.includes("edit");

  const [getPolicy, { 
    data: dataToken,
    error: tokenError,
    isError: isTokenError 
  }] = useGetPolicyNameMutation();
  const [
    getPolicyMask,
    {
      data: dataMask,
      error: maskError,
      isError: isMaskError
    },
  ] = useGetMaskPolicyNameMutation();

  // const { data: dataToken } = useGetTokenPolicyNameQueryQuery({ pagesize: 100 });
  // const { data: dataMask } = useGetMaskPolicyNameQueryQuery({ pagesize: 100 });
  // createDetokenMask
  const [
    createDetokenMask,
    {
      isSuccess: successDetokenMask,
      isError: errorDetokenMask,
      data: dataDetokenMask,
      error: dataErrorDetokenMask,
      isLoading: loadingDetokenMask,
    },
  ] = useCreateDetokenMaskMutation();

  // const { data: dataMaskPolicy } = useGetMaskPolicyDetailQuery(idParam);
  // REGION: INIT FORM DATA
  const {
    control,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<{
    policyName: string;
    policyMaskName: string;
    plaintext: string;
    result: string;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(detokenMask),
    defaultValues: {
      policyName: "",
      policyMaskName: "",
      plaintext: "",
      result: "",
    },
  });

  // REGION: SET FORM DATA
  useEffect(() => {
    console.log('Token Policies:', dataToken?.token_policies);
    if (dataToken) {
      setOptKey(
        dataToken?.token_policies?.map((item: any) => ({
          label: item.name,
          value: item.name,
        }))
      );
    }
  }, [dataToken]);

  useEffect(() => {
    console.log('Mask Policies:', dataMask?.mask_policies);
    if (dataMask) {
      setOptKeyMask(
        dataMask?.mask_policies?.map((item: any) => ({
          label: item.name,
          value: item.name,
        }))
      );
    }
  }, [dataMask]);

  // REGION: DISPATCH SUCCESS EVENT
  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        await getPolicy({ pagesize: 100 });
        await getPolicyMask({ pagesize: 100 });
      } catch (error) {
        console.error('Error fetching policies:', error);
      }
    };
    
    fetchPolicies();
  }, []);

  useEffect(() => {
    console.log('Token Policy Response:', {
      raw: dataToken,
      endpoint: 'getPolicy',
      timestamp: new Date().toISOString()
    });
    if (dataToken) {
      const mappedData = dataToken?.token_policies?.map((item: any) => ({
        label: item.name,
        value: item.name,
      }));
      console.log('Mapped Token Options:', mappedData);
      setOptKey(mappedData);
    }
  }, [dataToken]);

  useEffect(() => {
    console.log('Mask Policy Response:', {
      raw: dataMask,
      endpoint: 'getPolicyMask',
      timestamp: new Date().toISOString()
    });
    if (dataMask) {
      const mappedData = dataMask?.mask_policies?.map((item: any) => ({
        label: item.name,
        value: item.name,
      }));
      console.log('Mapped Mask Options:', mappedData);
      setOptKeyMask(mappedData);
    }
  }, [dataMask]);

  useEffect(() => {
    if (dataDetokenMask) {
      setValue("result", dataDetokenMask?.value);
    }
  }, [dataDetokenMask]);

  // REGION: DISPATCH INSERT & UPDATE DATA
  const onSubmit = (e: any) => {
    let tempVar = {
      policyName: `${e.policyName},${e.policyMaskName} `,
      tokenData: e.plaintext,
    };
    console.log("tempVar ===> ", e);
    //TO DO be continue here
    createDetokenMask(tempVar);
  };

  useEffect(() => {
    if (errorDetokenMask) {
      const dataError: any = dataErrorDetokenMask;
      // console.log('wkwkwk ===> ', dataErrorSign?.data)
      Swal.fire({
        icon: "error",
        title: "Error Create",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: dataError?.data?.error,
      });
    }
  }, [errorDetokenMask]);

  useEffect(() => {
    if (isTokenError) {
      console.error('Token Policy Error:', tokenError);
    }
    if (isMaskError) {
      console.error('Mask Policy Error:', maskError);
    }
  }, [isTokenError, isMaskError, tokenError, maskError]);

  // REGION: RETURN TSX
  return (
    <DetailDataSkeleton
      isLoading={false}
      isLoadingEvent={loadingDetokenMask}
      inputCount={6}
      titleWidth={"350px"}
    >
      <Box component="form" onSubmit={handleSubmit(onSubmit)} paddingY="20px">
        <Typography variant="h3" fontFamily="Open Sans" mb={3}>
          Detoken Mask
        </Typography>
        <SelectFormm
          name="policyName"
          label="Policy Name for Detokenize"
          defaultValue={0}
          options={optKey}
          placeholder="Please Select"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
        />
        <SelectFormm
          name="policyMaskName"
          label="Policy Name for Masking"
          defaultValue={0}
          options={optKeyMask}
          placeholder="Please Select"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
        />
        <InputForm
          name="plaintext"
          label="Tokenized Data"
          placeholder="Type Tokenized Data"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          maxLength={1000}
          required
        />

        <Stack
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
        >
          <Button variant="contained" type="submit">
            Detoken Mask
          </Button>
        </Stack>

        <Typography variant="h4" sx={{ fontWeight: "bold" }}>
          Result
        </Typography>
        <InputForm
          name="result"
          placeholder="Type Input Value"
          disabled={editFgroup}
          isLoading={false}
          control={control}
          errors={errors}
          maxLength={1000}
          required
        />
      </Box>
    </DetailDataSkeleton>
  );
};

export default DetokenMask;
